import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { resetPassword, clearAuthErrors } from '../../redux/auth/auth.actions';
import { selectAuthStatusResetPassword, selectAuthLoading, selectAuthErrors } from '../../redux/auth/auth.selectors';

import LoaderSimple from '../../components/Loaders/LoaderSimple/LoaderSimple';
import AuthErrorAlert from './AuthError/AuthErrorAlert';

import Logo2 from '../../components/Logo/Logo2';
import { InputEyeIcon, InputEyeCloseIconNew } from '../../components/Icon';

import './Auth.scss';


const ResetPassword = () => {
    document.title = 'Reset Password - DB Design';

    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    const authStatusResetPassword = useSelector(selectAuthStatusResetPassword);
    const isAuthLoading = useSelector(selectAuthLoading);
    const authError = useSelector(selectAuthErrors);

    const queryParams = new URLSearchParams(location.search);
    const tokenParam = queryParams.get('token');
    const errorParam = queryParams.get('error');

    const inputPasswordRef = useRef(null);

    const [password, setPassword] = useState('');
    const [isLoadingResetPass, setIsLoadingResetPass] = useState(false);

    const [isInvalidPassword, setIsInvalidPassword] = useState(false);
    const [isValidationStarted, setIsValidationStarted] = useState(false);

    const [isEnabledShowPassword, setIsEnabledShowPassword] = useState(false);

    const setValidationLoading = () => {
        setIsLoadingResetPass(true);
        setIsInvalidPassword(false);
        setTimeout(() => {
            setIsLoadingResetPass(false);
            setIsInvalidPassword(true);
            if (!isValidationStarted) {
                setIsValidationStarted(true);
            }
            inputPasswordRef.current.focus();
        }, 300);
    }

    const handleChange = (event) => {
        if (isValidationStarted) {
            handleValidation(event.target.value);
        }
        setPassword(event.target.value);
    }

    const handleValidation = (passwordValue) => {
        setIsInvalidPassword(!validatePassword(passwordValue));
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    const handleSubmit = () => {
        if (validatePassword(password)) {
            setIsLoadingResetPass(true);
            setTimeout(() => {
                setIsLoadingResetPass(false);
                dispatch(resetPassword({ newPassword: password, token: tokenParam }));
            }, 200);
        } else {
            setValidationLoading();
        }
    }

    const handleOnShowPassClick = () => {
        setIsEnabledShowPassword(!isEnabledShowPassword);
    }

    useEffect(() => {
        document.title = 'Reset Password - DB Design';
    }, []);

    useEffect(() => {
        if (isInvalidPassword) {
            inputPasswordRef.current.focus();
        }
    }, [isInvalidPassword]);

    useEffect(() => {
        inputPasswordRef.current.focus();
    }, [isAuthLoading]);

    const validatePassword = (passwordValue) => {
        return (passwordValue.length >= 12 && passwordValue.length <= 36);
    };

    useEffect(() => {
        if (authStatusResetPassword) {
            const url = `/password-updated`;
            history.push(url);
        }
    }, [authStatusResetPassword]);

    const handleBackClick = () => {
        setTimeout(() => {
            history.push('/login');
            dispatch(clearAuthErrors());
        }, 100);
    };

    if (errorParam || !tokenParam) {
        history.push('/error');
    }

    return (
        <div className="sign-in-box">
            <Logo2 />
            <div className={`sign-in-wrap ${authError ? 'error' : ''}`}>
                <div className={`sign-in`}>

                    {authError
                        ? <AuthErrorAlert isAuthLoading={isAuthLoading} error={authError} />
                        : ''}

                    <div className="sign-in-title">Reset your password</div>

                    <div className='edit-email-control'>
                        <input
                            maxLength="150"
                            ref={inputPasswordRef}
                            className={`auth-input show-password-control-input ${isInvalidPassword ? 'auth-input-invalid' : ''}`}
                            name="password"
                            type={isEnabledShowPassword ? "text" : "password"}
                            value={password}
                            disabled={isLoadingResetPass || isAuthLoading}
                            autoFocus={(window.innerWidth >= 1000)}
                            autoComplete="password"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck="false"
                            inputMode="password"
                            placeholder="Enter new password"
                            aria-label="Enter new password"
                            onChange={handleChange}
                            onKeyDown={handleKeyPress}
                        ></input>

                        <button
                            type="button"
                            className='edit-email-control-button'
                            onClick={handleOnShowPassClick}
                        >
                            {isEnabledShowPassword ? <InputEyeCloseIconNew /> : <InputEyeIcon />}
                        </button>
                    </div>
                    {isInvalidPassword && password.length < 12 ? <p className='auth-validation-text'>{`Password must be at least 12 characters.${password.length ? ` Now it's ${password.length}.` : ''}`}</p> : ''}
                    {isInvalidPassword && password.length > 36 ? <p className='auth-validation-text'>{`Password must be less than 36 characters.${password.length ? ` Now it's ${password.length}.` : ''}`}</p> : ''}

                    <button
                        disabled={isLoadingResetPass || isAuthLoading}
                        className="auth-btn-submit s_forgot"
                        type="submit"
                        onClick={handleSubmit}
                    >{isLoadingResetPass || isAuthLoading ? <LoaderSimple /> : 'Reset password'}</button>

                    <button
                        className="auth-btn-back"
                        type="button"
                        onClick={handleBackClick}
                    >Back</button>
                </div>
            </div>
        </div>
    )
};

export default ResetPassword;
